Intl = require 'intl'
{ locales } = require 'db/locale-information'

formatter = null
module.exports = (num) ->
  formatter ?= new Intl.NumberFormat locales[0],
    style: 'percent'
    minimumFractionDigits: 4
    maximumFractionDigits: 4
  formatter.format(num)



// WEBPACK FOOTER //
// ./app/scripts/lib/format/tax-rate.coffee